export default "__VITE_ASSET__D_mt7bp6__"